export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';
export const BOSC_ID = +process.env.REACT_APP_BOSC_ID || 0;
export const WFH_COMPANY_IDS = (process.env.REACT_APP_WFH_COMPANY_IDS || '').split(',').map(Number).filter(Boolean);
